module.exports = __webpack_public_path__ + "img/caroffAggregation.2a0f698d.svg";